import { onMediumScreen } from 'mixtiles-web-common'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px 20px;
  max-width: 380px;
  gap: 16px;

  ${onMediumScreen()} {
    margin: 86px 0;
    gap: 28px;
    padding: 0;
    max-width: unset;
  }
`

export const Title = styled.h2`
  font-size: 22px;
  line-height: 1.2;
  margin: 0;
  font-weight: 600;

  ${onMediumScreen()} {
    font-size: 44px;
    line-height: 44px;
  }
`

export const Description = styled.p`
  font-size: 16px;
  white-space: pre-wrap;
  margin: 0;

  ${onMediumScreen()} {
    font-size: 28px;
    line-height: 42px;
  }
`
